import { formatPrice } from '~helpers';

export enum DECIMAL_DISPLAY {
  NONE,
  HIDE_ZERO,
  ALWAYS,
}

interface FormattedCurrencyProps {
  /** Currency of the price */
  currency: string;
  /** Value of the price */
  value: number;
  /** Controls display of decimals (ALWAYS by default) */
  decimalDisplay?: DECIMAL_DISPLAY;
}

/** Description du composant FormattedCurrency */
const FormattedCurrency = ({
  currency,
  value,
  decimalDisplay = DECIMAL_DISPLAY.ALWAYS,
}: FormattedCurrencyProps) => {
  const finalValue = value / 100;

  if (decimalDisplay === DECIMAL_DISPLAY.NONE) {
    return formatPrice('fr-FR', currency, Math.trunc(finalValue), 0);
  }

  const formattedPrice = formatPrice('fr-FR', currency, finalValue);

  if (decimalDisplay === DECIMAL_DISPLAY.HIDE_ZERO) {
    return formattedPrice.replace(/,(00)(?=\D*$)/, '');
  }

  return formattedPrice;
};

export default FormattedCurrency;
